import * as React from "react";
import type { SVGProps } from "react";
const SvgSpray = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.01 3c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1M11 9.18V8c.55 0 1-.45 1-1s-.45-1-1-1c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v3.18c-1.16.41-2 1.51-2 2.82v7c0 1.65 1.35 3 3 3h4c1.65 0 3-1.35 3-3v-7c0-1.3-.84-2.4-2-2.82M9 6v3H7V6zm2 13c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zm4.01-13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m2 3c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1m1-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m3 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m-1 5c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSpray;
